"use client";

import { c as _c } from "react/compiler-runtime";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { CheckIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
type VoteFeedbackSource = "custom-submit" | "quick-amount";
interface MemesQuickVoteAmountButtonProps {
  readonly amount: number;
  readonly feedbackAmount: number | null;
  readonly feedbackSource: VoteFeedbackSource | null;
  readonly isLatestUsed: boolean;
  readonly isSubmitting: boolean;
  readonly isVoteFeedbackActive: boolean;
  readonly onVoteAmount: (amount: number) => void;
}
export default function MemesQuickVoteAmountButton(t0) {
  const $ = _c(16);
  const {
    amount,
    feedbackAmount,
    feedbackSource,
    isLatestUsed,
    isSubmitting,
    isVoteFeedbackActive,
    onVoteAmount
  } = t0;
  const isNegativeAmount = amount < 0;
  const isQuickVoteFeedbackTarget = isVoteFeedbackActive && feedbackSource === "quick-amount" && feedbackAmount === amount;
  let buttonToneClassName = isNegativeAmount ? "tw-border-rose-500/25 tw-bg-rose-500/10 tw-text-[14px] tw-font-bold tw-text-rose-200 tw-shadow-sm tw-transition-colors desktop-hover:hover:tw-bg-rose-500/15 desktop-hover:hover:tw-text-rose-100" : "tw-border-white/5 tw-bg-white/[0.03] tw-text-[14px] tw-font-bold tw-text-zinc-300 tw-shadow-sm tw-transition-colors desktop-hover:hover:tw-bg-white/[0.06] desktop-hover:hover:tw-text-white";
  if (isQuickVoteFeedbackTarget) {
    buttonToneClassName = isNegativeAmount ? "tw-border-rose-500/40 tw-bg-rose-500/20 tw-text-rose-100 tw-shadow-[0_0_20px_rgba(244,63,94,0.14)]" : "tw-border-emerald-500/35 tw-bg-emerald-500/15 tw-text-emerald-100 tw-shadow-[0_0_20px_rgba(16,185,129,0.15)]";
  } else {
    if (isLatestUsed) {
      buttonToneClassName = isNegativeAmount ? "tw-border-rose-500/35 tw-bg-rose-500/15 tw-text-rose-200 tw-shadow-sm tw-transition-all desktop-hover:hover:tw-bg-rose-500/25 desktop-hover:hover:tw-text-rose-100" : "tw-border-blue-500/30 tw-bg-blue-500/15 tw-text-primary-300 tw-shadow-sm tw-transition-all desktop-hover:hover:tw-bg-blue-500/25 desktop-hover:hover:tw-text-primary-200";
    }
  }
  let t1;
  if ($[0] !== amount || $[1] !== onVoteAmount) {
    t1 = () => {
      onVoteAmount(amount);
    };
    $[0] = amount;
    $[1] = onVoteAmount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isVoteFeedbackActive && !isQuickVoteFeedbackTarget && "tw-opacity-40";
  let t3;
  if ($[3] !== buttonToneClassName || $[4] !== t2) {
    t3 = clsx("tw-relative tw-inline-flex tw-h-full tw-min-w-14 tw-flex-none tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-text-center active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 sm:tw-min-w-[4.5rem] sm:tw-flex-1 sm:tw-basis-0 lg:tw-min-w-14 lg:tw-flex-none", buttonToneClassName, t2);
    $[3] = buttonToneClassName;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== amount || $[7] !== isLatestUsed || $[8] !== isNegativeAmount || $[9] !== isQuickVoteFeedbackTarget) {
    t4 = isQuickVoteFeedbackTarget ? <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-font-bold tw-leading-none"><CheckIcon className="tw-size-4 tw-shrink-0" /><span>{formatNumberWithCommas(amount)}</span></span> : <span className={clsx("tw-font-bold tw-leading-none", isLatestUsed && (isNegativeAmount ? "tw-text-rose-200" : "tw-text-primary-300"))}>{formatNumberWithCommas(amount)}</span>;
    $[6] = amount;
    $[7] = isLatestUsed;
    $[8] = isNegativeAmount;
    $[9] = isQuickVoteFeedbackTarget;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isSubmitting || $[12] !== t1 || $[13] !== t3 || $[14] !== t4) {
    t5 = <button type="button" onClick={t1} disabled={isSubmitting} className={t3}>{t4}</button>;
    $[11] = isSubmitting;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}